// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert_title[data-v-8f82d0e2] {\n  margin-left: 20px;\n  width: 240px;\n}", ""]);
// Exports
module.exports = exports;
